import React, { useState, useEffect } from 'react';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import logo from '../assets/images/logo.svg';
import passwordeye from '../assets/images/eye.svg';
import FeaturedPost from '../components/FeaturedPost';
import Footer from '../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import config from '../config/config';

const CreatorRegister = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role_type: 'creator',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
    setErrorMessage(''); // Clear error message on input change
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/Home');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading

    // Name validation (only alphabets allowed)
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name)) {
      setErrorMessage('Name should contain only alphabets.');
      setLoading(false); // Stop loading
      return;
    }

    // Email validation (basic regex for email format)
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (!emailRegex.test(formData.email)) {
      setErrorMessage('Please enter a valid email address.');
      setLoading(false); // Stop loading
      return;
    }

    // Password validation (strong password check)
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(formData.password)) {
      setErrorMessage('Password must contain at least 8 characters, including one uppercase, one lowercase, one number, and one special character.');
      setLoading(false); // Stop loading
      return;
    }

    try {
      const response = await fetch(`${config.baseURL}/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Registration failed');
      }

      if (result.success === false && result.error === true) {
        setErrorMessage(result.message); // Set error message from the API
      } else {
        console.log('Registration successful:', result);
        setSuccessMessage('Account created successfully!');

        // Store token in localStorage
        if (result.token) {
          localStorage.setItem('token', result.token);
        }

        // Redirect to the homepage
        setTimeout(() => {
          navigate('/Home');
        }, 2000);
      }
    } catch (error) {
      console.error('Registration failed:', error);
      setErrorMessage(error.message); // Set error message from the catch block
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div>
      <div className="login_wrap">
        <div className="login_wrap_container">
          <div className="right_login_box">
            <div className="img_content">
              <img src={logo} alt="logo" />
              <h4>Sign up to support your favorite creators</h4>
            </div>
          </div>
          <div className="left_login_box">
            <div className="login_box">
              <div id="form-container">
                <form id="signupForm" onSubmit={handleSubmit}>
                  <p className="p_sub_head">Signup as a creator</p>
                  <div className="mb-4 position_relative">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    <label htmlFor="name" className="placeholder-label">Name</label>
                  </div>
                  <div className="mb-4 position_relative">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <label htmlFor="email" className="placeholder-label">Email</label>
                  </div>
                  <div className="mb-4 pwd_side position_relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      id="password"
                      placeholder="Password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <label htmlFor="password" className="placeholder-label">Password</label>
                    <img
                      className="password-toggle"
                      src={passwordeye}
                      alt="Show Password"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                  <input type="hidden" id="role_type" value="creator" />

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}

                  <div className="d-grid my-4 mb-0">
                    <button className="btn btn-primary" type="submit" disabled={loading}>
                      {loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        "Sign Up"
                      )}
                    </button>
                  </div>
                  <div className="small_text">
                    By signing up you agree to our <Link to="/terms">Terms of Service</Link> and <Link to="/privacy">Privacy Policy</Link>, and confirm that you are at least 18 years old.
                  </div>
                  <div className="row">
                    <div className="col text-end space_texts text-center account_already">
                      Already have an account? <Link to="/login" className="login">Log in</Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="social_logins">
              <Link to="/register" className="button button--social-login button--create">Signup as a user</Link>
            </div>
          </div>
        </div>
      </div>
      <FeaturedPost />
      <Footer />
    </div>
  );
};

export default CreatorRegister;
